/**
 * Dev-only routes — usernames allowed to open hidden UI (not in sidebar).
 * Backend twin: server/includes/functions/status_discrepancy_access.php
 */
export const STATUS_DISCREPANCY_ALLOWED_USERNAMES = ['testuser', 'michaels'];

export function isStatusDiscrepancyDevUser(username) {
  return STATUS_DISCREPANCY_ALLOWED_USERNAMES.includes(username ?? '');
}
